import React from "react";
import { motion } from "framer-motion";

export const Section = ({ children, className = "", id }) => (
  <section id={id} className={`relative mx-auto max-w-[1400px] px-6 md:px-10 py-24 md:py-32 ${className}`}>
    {children}
  </section>
);

export const Eyebrow = ({ children }) => (
  <div className="inline-flex items-center gap-3">
    <span className="h-px w-8 bg-[#FF9933]" />
    <span className="text-[11px] uppercase tracking-[0.4em] text-[#FF9933]">{children}</span>
  </div>
);

export const H2 = ({ children, hindi }) => (
  <div>
    {hindi && <div className="font-hindi text-2xl md:text-3xl text-white/80 mb-3">{hindi}</div>}
    <h2 className="font-display text-4xl md:text-6xl leading-[1.02] tracking-tight text-white">{children}</h2>
  </div>
);

export const Reveal = ({ children, delay = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const PageHeader = ({ eyebrow, hindi, title, subtitle }) => (
  <section className="relative pt-40 pb-16 md:pt-48 md:pb-24 overflow-hidden">
    <div className="absolute inset-0 hero-radial opacity-70" />
    <div className="relative mx-auto max-w-[1400px] px-6 md:px-10">
      <Eyebrow>{eyebrow}</Eyebrow>
      <div className="mt-6 max-w-4xl">
        {hindi && <div className="font-hindi text-2xl md:text-3xl text-[#FF9933]/90">{hindi}</div>}
        <h1 className="mt-2 font-display text-5xl md:text-7xl leading-[1.02] tracking-tight text-white">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-6 max-w-2xl text-base md:text-lg text-white/70 leading-relaxed">{subtitle}</p>
        )}
      </div>
      <div className="mt-10 divider-saffron" />
    </div>
  </section>
);
